export const PAY_LOAN_START = 'PAY_LOAN_START';
export const PAY_LOAN_SUCCESS = 'PAY_LOAN_SUCCESS';
export const PAY_LOAN_ERROR = 'PAY_LOAN_ERROR';
export const PAY_LOAN_END = 'PAY_LOAN_END';
export const CLEAR_PAY_LOAN = 'CLEAR_PAY_LOAN';
